/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Box, Text, xcss } from '@atlaskit/primitives';
import WeekDayGrid from './week-day-grid';
var columnHeaderStyles = xcss({
  minWidth: 'size.400',
  // Account for languages with short week day names
  whiteSpace: 'nowrap',
  // Account for languages with long week day names
  display: 'flex',
  justifyContent: 'center'
});
var WeekHeader = /*#__PURE__*/memo(function WeekHeader(_ref) {
  var daysShort = _ref.daysShort,
    testId = _ref.testId;
  return jsx(WeekDayGrid, {
    isHidden: true,
    testId: testId && "".concat(testId, "--column-headers")
  }, daysShort.map(function (shortDay) {
    return jsx(Box, {
      padding: "space.100",
      xcss: columnHeaderStyles,
      key: shortDay,
      role: "columnheader",
      testId: testId && "".concat(testId, "--column-header")
    }, jsx(Text, {
      weight: "bold",
      size: "UNSAFE_small",
      align: "center",
      color: "color.text.subtle"
    }, shortDay));
  }));
});
WeekHeader.displayName = 'WeekHeader';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default WeekHeader;